import React from 'react'
import leftBanner from '../assets/images/login.png'
const PreLoginBanner = () => {
  return (
    <>
            
                <img src= {leftBanner} alt='leftBanner' className='img-full-height'/>
                {/* <img src= {leftBanner} alt='leftBanner' className='img-fluid'/> */}
           
     
    </>
  )
}

export default PreLoginBanner